// Sub-navegação do módulo Central de IA (contrato ui-components §1). Ordem das abas
// (wireframes §0 + spec-001 project-ia-payment):
// Catálogo · Meus Agentes · Conversar · Créditos | Aprovações (N) · Execuções · Uso.
// ★ Aprovações e Uso só aparecem para gestor (`isGestor`). O badge (N) da aba Aprovações
// vem de `pendingCount` — OCULTO quando 0 (NC-16), embutido no título (a NavBarNavigation
// renderiza só o texto da aba). Names das 3 rotas novas = kebab (contrato §1).
const BASE_ROUTES = [
  { name: 'aiFrameworkCatalog', title: 'Catálogo' },
  { name: 'aiFrameworkMyAgents', title: 'Meus Agentes' },
  { name: 'aiFrameworkConversar', title: 'Conversar' },
  // ★ Fecha o grupo do consultor (spec-001, US-1) — antes das abas de auditoria, que
  // são leitura sobre o escritório. O rótulo não repete "Meus" (a aba vizinha já é
  // "Meus Agentes"); quem diz de quem é o saldo é o título do card, "Meus créditos".
  // Visível para TODOS: a carteira é por profissional (ADR-008), não é tela de gestor.
  { name: 'aiFrameworkCreditos', title: 'Créditos' },
]

export function buildNavRoutes({ isGestor = false, pendingCount = 0 } = {}) {
  const routes = BASE_ROUTES.slice()

  if (isGestor) {
    const badge = pendingCount > 0 ? ' (' + pendingCount + ')' : ''
    routes.push({ name: 'ai-framework-aprovacoes', title: 'Aprovações' + badge })
  }

  routes.push({ name: 'ai-framework-execucoes', title: 'Execuções' })

  if (isGestor) {
    routes.push({ name: 'ai-framework-uso', title: 'Uso' })
  }

  return routes
}
